import { immerable } from 'immer';

import { NotificationTypeEnum } from 'api/enums';
import { IUserModel, UserModel } from './user.model';

/* -------------------------------------------------------------------------------------------------
 * INotificationModel
 * -----------------------------------------------------------------------------------------------*/
export interface INotificationModel {
    _id: string;
    type: NotificationTypeEnum;
    message: string;
    details: any;
    createdBy: Pick<IUserModel, 'name' | 'dpUrl' | 'preset'>;
    read: boolean;
    createdAt: Date;
}

/* -------------------------------------------------------------------------------------------------
 * NotificationModel
 * -----------------------------------------------------------------------------------------------*/
export class NotificationModel {
    [immerable] = true;

    _id: string;
    type: NotificationTypeEnum;
    message: string;
    details: any;
    read: boolean;
    createdAt: Date;

    // Relationships
    createdBy: Pick<UserModel, 'name' | 'dpUrl' | 'preset'>;

    constructor(data: Partial<INotificationModel>) {
        this._id = data._id ?? '';
        this.type = data.type ?? null;
        this.message = data.message ?? '';
        this.details = data.details ?? null;
        this.read = data.read ?? null;
        this.createdAt = data.createdAt ?? null;

        if (data.createdBy) {
            this.createdBy = UserModel.fromObject(data.createdBy);
        } else {
            this.createdBy = null;
        }
    }

    static fromObject(data: Partial<INotificationModel>): NotificationModel {
        const model = new NotificationModel(data);

        return model;
    }

    static fromObjectList(data: Partial<INotificationModel>[]): NotificationModel[] {
        return data.map((row) => NotificationModel.fromObject(row));
    }

    toObject(): INotificationModel {
        const data: Partial<INotificationModel> = {
            _id: this._id,
            type: this.type,
            message: this.message,
            details: this.details,
            read: this.read,
            createdAt: this.createdAt,
        };

        if (this.createdBy) {
            if (this.createdBy instanceof UserModel) {
                data.createdBy = this.createdBy.toObject();
            } else {
                data.createdBy = this.createdBy;
            }
        }

        return data as INotificationModel;
    }
}
